<template>
  <transition name="showHeader">
    <div v-if="visible" class="header-animat">
      <a-layout-header
        v-if="visible"
        :class="[fixHeader && 'ant-header-fixedHeader', sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed', ]"
        :style="{ padding: '0' }">
        <div class="header">
          <router-link class="backto" :to="{ path: links }" title="返回店铺">
            <span>店铺</span>
          </router-link>
          <!-- <logo /> -->
          <user-menu></user-menu>
        </div>
      </a-layout-header>
    </div>
  </transition>
</template>

<script>
import UserMenu from '../tools/UserMenu';

import config from '@/config';

export default {
  name: 'BackHeader',
  components: {
    UserMenu,
  },
  props: {
    mode: {
      type: String,
      default: 'sidemenu' // sidemenu, topmenu
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    device: {
      type: String,
      required: false,
      default: 'desktop'
    }
  },
  data () {
    return {
      visible: true,
      oldScrollTop: 0,
      autoHideHeader: false, // 设置右侧全局头部是否置顶
      links: config.defaultRoutePath,
    };
  },
  mounted () {
    document.body.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  methods: {
    handleScroll () {
      if (!this.autoHideHeader) {
        return;
      }

      const scrollTop = document.body.scrollTop + document.documentElement.scrollTop;
      if (!this.ticking) {
        this.ticking = true;
        requestAnimationFrame(() => {
          if (this.oldScrollTop > scrollTop) {
            this.visible = true;
          } else if (scrollTop > 300 && this.visible) {
            this.visible = false;
          } else if (scrollTop < 300 && !this.visible) {
            this.visible = true;
          }
          this.oldScrollTop = scrollTop;
          this.ticking = false;
        });
      }
    },
    toggle () {
      this.$emit('toggle');
    }
  },
  beforeUnmount () {
    document.body.removeEventListener('scroll', this.handleScroll, true);
  }
};
</script>

<style lang="less">
.header-animat{
  position: relative;
  z-index: 2;
}
.showHeader-enter-active {
  transition: all 0.25s ease;
}
.showHeader-leave-active {
  transition: all 0.5s ease;
}
.showHeader-enter, .showHeader-leave-to {
  opacity: 0;
}

// 头部修改
.header {
  .logo {
    position: relative;
    height: 64px;
    padding-left: 24px;
    overflow: hidden;
    line-height: 64px;
    transition: all 0.3s;
    display: block;
    float: left;

    a {
      text-decoration: none;
      background-color: transparent;
      outline: none;
      cursor: pointer;
      transition: color 0.3s;

      img {
        width: 32px;
        height: 32px;
        vertical-align: middle;
        display: inline-block;
      }

      h1 {
        font-size: 16px;
        margin: 0 0 0 5px;
        font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
        font-weight: 600;
        color: #3842D2;
        vertical-align: middle;
        display: inline-block;
      }
    }
  }

  .backto {
    height: 64px;
    margin-left: 24px;
    color: inherit;
    display: block;
    float: left;

    i {
      font-size: 21px;
      line-height: 64px;
      vertical-align: middle;
    }

    span {
      line-height: 64px;
      margin-left: 10px;
      display: inline-block;
    }

    &:hover {
      color: #3842D2;
    }
  }
}

.layout.ant-layout.tablet {
  .logo {
    h1 {
      display: none;
    }
  }
}

.layout.ant-layout.mobile {
  .logo {
    display: none;
  }

  .backto {
    span {
      display: none;
    }
  }
}
</style>
